/**
 * KAN-849: collapsed block for technical channel fields (schema flag
 * `advanced: true`). Collapsed by default; it only hides the inputs, the field
 * values stay in the parent form state and are sent on save as usual.
 */
import { useState, type ReactNode } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

export const ADVANCED_FIELDS_TITLE = 'Технические настройки (не менять)';

export interface ChannelAdvancedFieldsProps {
  /** Channel codename, used for test ids and the aria link. */
  codename: string;
  /** Rendered field inputs. */
  children: ReactNode;
}

export function ChannelAdvancedFields({ codename, children }: ChannelAdvancedFieldsProps) {
  const [open, setOpen] = useState(false);
  const bodyId = `channel-advanced-body-${codename}`;

  return (
    <div
      data-testid={`channel-advanced-${codename}`}
      className="rounded-md border border-border">
      <button
        type="button"
        data-testid={`channel-advanced-toggle-${codename}`}
        aria-expanded={open}
        aria-controls={bodyId}
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm font-medium text-muted-foreground hover:text-foreground">
        {open ? (
          <ChevronDown className="h-4 w-4 shrink-0" />
        ) : (
          <ChevronRight className="h-4 w-4 shrink-0" />
        )}
        {ADVANCED_FIELDS_TITLE}
      </button>
      {open && (
        <div id={bodyId} className="space-y-4 border-t border-border p-3">
          {children}
        </div>
      )}
    </div>
  );
}

export default ChannelAdvancedFields;
